var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    viewBox: "0 0 20.734 27.646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "file-excel-solid",
    d: "M3.456,0A3.459,3.459,0,0,0,0,3.456V24.19a3.459,3.459,0,0,0,3.456,3.456H17.279a3.459,3.459,0,0,0,3.456-3.456V8.639H13.823A1.726,1.726,0,0,1,12.1,6.911V0ZM13.823,0V6.911h6.911ZM8.407,13.51l1.96,2.8,1.96-2.8a1.295,1.295,0,0,1,2.122,1.485l-2.5,3.58,2.505,3.575a1.295,1.295,0,1,1-2.122,1.485l-1.965-2.8-1.96,2.8a1.295,1.295,0,0,1-2.122-1.485l2.5-3.575L6.28,15A1.295,1.295,0,0,1,8.4,13.515Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateIcon);
export default __webpack_public_path__ + "static/media/activate-icon.7a045b89e08d2c32858ab7f821c25f53.svg";
export { ForwardRef as ReactComponent };